import { Carousel } from 'antd';
import styled from 'styled-components';

export const CarouselContainerStyled = styled(`div`)`
	max-width: calc(100vw - 32px);
`;

export const CarouselStyled = styled(Carousel)`
	margin-top: 30px;
	margin-bottom: 24px;
`;

export const CarouselItemStyled = styled(`div`)`
	aspect-ratio: 1817 / 1160;

	background-size: cover;
`;
